// extracted by mini-css-extract-plugin
module.exports = {"address_autocomplete":"AddressAutocomplete_address_autocomplete__XiDor","suggestions_panel":"AddressAutocomplete_suggestions_panel__YKzPV"};